import { render } from "./checkbox-radio.vue?vue&type=template&id=92fe16fc"
import script from "./checkbox-radio.vue?vue&type=script&lang=js"
export * from "./checkbox-radio.vue?vue&type=script&lang=js"

import "./checkbox-radio.vue?vue&type=style&index=0&id=92fe16fc&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__